import { render, staticRenderFns } from "./virtualTable.vue?vue&type=template&id=4a206726&"
import script from "./virtualTable.vue?vue&type=script&lang=js&"
export * from "./virtualTable.vue?vue&type=script&lang=js&"
import style0 from "./virtualTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports